/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  AddReactionRequest,
  MoveToTeamRequest,
  NoData,
  RemoveReactionRequest,
  RemoveStickyRequest,
} from "./models";
import { noDataSchema } from "./schemas";

export class StickyApiClient {
  constructor(private caller: ApiCaller) {}

  async deleteSticky(
    payload: RemoveStickyRequest,
    stickyId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.sticky.v1.stickies.${stickyId}.delete",
        variables: { stickyId: String(stickyId) },
      },
      "deleteSticky",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async moveToTeam(
    payload: MoveToTeamRequest,
    stickyId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.sticky.v1.stickies.${stickyId}.move",
        variables: { stickyId: String(stickyId) },
      },
      "moveToTeam",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async addReaction(
    payload: AddReactionRequest,
    stickyId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky.v1.stickies.${stickyId}.reactions.add",
        variables: { stickyId: String(stickyId) },
      },
      "addReaction",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async removeReaction(
    payload: RemoveReactionRequest,
    stickyId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.sticky.v1.stickies.${stickyId}.reactions.delete",
        variables: { stickyId: String(stickyId) },
      },
      "removeReaction",
      payload,
      { schema: noDataSchema, timeout },
    );
  }
}
